import { numeralFormatter } from 'ns_libs/formatter';
import { IDealUnitType } from 'views/Deals/types';
import { COST_BASIS_TYPES } from 'views/DealDashboard/BOE/components/SlideoutForm/constants';
import { IProFormaWizardStep2 } from './types';

export const getHardCostsAndTotals = (
    boeHardCostsUnitType: string,
    boeSoftCostsUnitType: string,
    wizardBuiltGrossSF: number,
    stepData: IProFormaWizardStep2 | undefined,
    dealUnits: IDealUnitType | undefined,
) => {
    const hardCostSubdiv = boeHardCostsUnitType === COST_BASIS_TYPES.PER_UNIT ? dealUnits?.value || 0 : wizardBuiltGrossSF;
    const softCostSubdiv = boeSoftCostsUnitType === COST_BASIS_TYPES.PER_UNIT ? dealUnits?.value || 0 : wizardBuiltGrossSF;

    let hardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)) / hardCostSubdiv, '0.00'));
    let totalHardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)), '0.00'));
    let softCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)) / softCostSubdiv, '0.00'));
    let totalSoftCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)), '0.00'));

    if (boeHardCostsUnitType === COST_BASIS_TYPES.TOTAL) {
        hardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)) / wizardBuiltGrossSF, '0.00'));
        totalHardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)), '0.00'));
    }

    if (boeSoftCostsUnitType === COST_BASIS_TYPES.TOTAL) {
        softCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)) / wizardBuiltGrossSF, '0.00'));
        totalSoftCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)), '0.00'));
    }

    return {
        hardCosts,
        totalHardCosts,
        softCosts,
        totalSoftCosts,
    };
};
